import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { getAllNotifications, markAllAsRead, markAllAsReadSuccess, markReadNotification, markReadSuccess, saveAllNotifications, updateAllNotifications } from "../slices";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";
import { ToastNotifyError } from "../../helpers/toast-helper";

interface ResponseGenerator {
  config?: any,
  data?: any,
  headers?: any,
  request?: any,
  status?: number,
  statusText?: string
  code?: string
}

function* fetchAllNotifications(action: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.NOTIFICATIONS.getAllOtherNotifications(),
      data: action.payload,
    });
    if (action.payload.lastKey) {
      yield put(updateAllNotifications(response));
    }
    else {
      yield put(saveAllNotifications(response));
    }
  } catch (error) {
    console.log(error);
  }
}

function* markAsReadNotificationFunc(action: any) {
  try {
    yield api.request({
      method: "POST",
      url: ENDPOINT.NOTIFICATIONS.markAsReadNotification(),
      data: action.payload,
    });
    yield put(markReadSuccess(action.payload?.messageIds));
  } catch (error) {
    console.log("error", error);
  }
}

function* markAllAsReadFunc() {
  try {
    yield api.request({
      method: "PUT",
      url: ENDPOINT.NOTIFICATIONS.markAllAsRead(),
    });
    yield put(markAllAsReadSuccess());
  } catch (error) {
    ToastNotifyError("error");
    console.log("error", error);
  }
}

export default function* root() {
  yield takeLatest(getAllNotifications.type, fetchAllNotifications);
  yield takeEvery(markReadNotification.type, markAsReadNotificationFunc);
  yield takeEvery(markAllAsRead.type, markAllAsReadFunc);
}